import { Validators } from '@angular/forms';
import { ControlProperty, ControlStringProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { ListQueryParam, Role } from '../../../../../common/constants';
import { NewsletterStatus } from '../constants';
import { UserRolesModel } from '../../user';

export class Newsletter {
  id?: number = null;
  documentId?: string = null;
  data?: string = null;
  name: string = null;
  constructor(params?: Newsletter) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class NewsletterItem extends Newsletter {
  status: NewsletterStatus = null;
  sentTimestamp: number = null;
  uploadTimestamp: number = null;
  type: string = null;
  receiverRoles: Role[] | UserRolesModel = [];
  sendToSubscribedUsersOnly = false;
  constructor(params?: NewsletterItem) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class NewsletterListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.Status]: string;
  [ListQueryParam.Sort] = 'uploadTimestamp:desc';
  [ListQueryParam.Type]: string;

  constructor(params?: Partial<NewsletterListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class NewsletterItemForm {
  id?;
  documentId?;

  constructor(
    newsletterItemModel: NewsletterItem,
    public name: ControlStringProperty = [newsletterItemModel.name, [Validators.required]],
    public data: [string, Validators | Validators[]] = [
      newsletterItemModel.data || null,
      newsletterItemModel.documentId ? [] : [Validators.required],
    ],
    public type: ControlStringProperty = [newsletterItemModel.type, []],
    public receiverRoles: ControlProperty<Role[] | UserRolesModel> = [newsletterItemModel.receiverRoles, []],
    public sendToSubscribedUsersOnly: ControlProperty<boolean> = [newsletterItemModel.sendToSubscribedUsersOnly, []],
  ) {
    this.documentId = [newsletterItemModel.documentId || null, []];
    this.id = [newsletterItemModel.id || null, []];
  }
}
